module.exports = __webpack_public_path__ + "static/media/SFMono-MediumItalic.ae7ea80f.woff2";